import moment from 'moment';
import { muiTheme } from 'cityads-v3/utils/styleUtils';

export const ALERTS_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const ALERTS_ADDED_AT_FORMAT = 'YYYY-MM-DD HH:mm';
export const CHART_TOOLTIP_DATE_FORMAT_TIME = 'D MMM H:mm';
export const CHART_TOOLTIP_DATE_FORMAT = 'D MMM';
export const EXCLUDED_FILTERS = ['chart'];

export const ALERT_TYPE_POSITIVE = 1;
export const ALERT_TYPE_NEGATIVE = 2;

export const MY_ALERTS = 1;
export const ALL_ALERTS = 2;

export const ALERT_TYPE_STYLE = {
  [ALERT_TYPE_POSITIVE]: { backgroundColor: '#e2ffe0' },
  [ALERT_TYPE_NEGATIVE]: { backgroundColor: '#ffd7cc' },
};

export const ALERT_TYPE_STYLE_DARK = {
  [ALERT_TYPE_POSITIVE]: { backgroundColor: '#033300' },
  [ALERT_TYPE_NEGATIVE]: { backgroundColor: '#330c00' },
};

export const ALERT_METRIC_COMMISSION_APPROVED = 3;
export const ALERT_METRIC_ECPC = 4;
export const ALERT_METRIC_REAPPLIED_SYSTEM_DELTA = 1001;

export const FIELDS_TO_FILTER = {
  id: value => Boolean(value) ? {id: value} : {},
  added_at: date => (date ? {
    added_at: {
      '>=': moment(date[0]).format(ALERTS_DATE_FORMAT),
      '<=': moment(date[1]).format(ALERTS_DATE_FORMAT),
    }
  } : {}),
  alert_metric: value => ({alert_metric: value}),
  math_expectation: value => value && value.value && {math_expectation: {[value.expression]: value.value}},
  actual_deviation: value => value && value.value && {actual_deviation: {[value.expression]: value.value / 100}},
  offer_id: value => ({offer_ids: value}),
  webmaster_id: value => ({webmaster_ids: value}),
  periods_measurements: value => ({}),
  alert_slice: value => ({alert_slice: value}),
  chart: () => {}
};


export function tooltipDate(start, end, showTime = false) {
  const startDate = moment(start, ALERTS_DATE_FORMAT).format(showTime ? CHART_TOOLTIP_DATE_FORMAT_TIME : CHART_TOOLTIP_DATE_FORMAT);
  const endDate = moment(end, ALERTS_DATE_FORMAT).format(showTime ? CHART_TOOLTIP_DATE_FORMAT_TIME : CHART_TOOLTIP_DATE_FORMAT);
  return `${startDate} - ${endDate}`
}


export function monitoringAlertsMap(data) {
  return data.alerts.map(row => {

    const periods_measurements_keys = Object.keys(row.periods_measurements).reverse();
    let minValue = Number.POSITIVE_INFINITY;
    let maxValue = Number.NEGATIVE_INFINITY;
    let minValuableValue = Number.POSITIVE_INFINITY;
    let maxValuableValue = Number.NEGATIVE_INFINITY;
    let valuablesCount = 0;
    const chart_points = periods_measurements_keys.map((date, i) => {
      const item = row.periods_measurements[date];
      const isValuable = (i === periods_measurements_keys.length - 1) || (row.valuable_measurements.indexOf(item.value) >= 0);

      if (item.value > maxValue) {
        maxValue = item.value;
      }

      if (item.value < minValue) {
        minValue = item.value;
      }

      if (isValuable) {
        valuablesCount++;

        if (item.value > maxValuableValue) {
          maxValuableValue = item.value;
        }

        if (item.value < minValuableValue) {
          minValuableValue = item.value;
        }
      }

      return {
        x: i,
        y: item.value,
        label: tooltipDate(item.period[0], item.period[1], row.alert_slice === 1),
        color: isValuable ? muiTheme.palette.primary.main : '#cccccc',
      }
    });

    if(chart_points.length) {
      chart_points[chart_points.length - 1].color = row.alert_type === ALERT_TYPE_NEGATIVE ? '#cc553d' : '#2bb021'
    }

    return {
      ...row,
      chart_points,
      min_value: minValue,
      max_value: maxValue,
      min_valuable_value: minValuableValue,
      max_valuable_value: maxValuableValue,
      valuables_count: valuablesCount,
      added_at: moment(row.added_at, ALERTS_DATE_FORMAT).format(ALERTS_ADDED_AT_FORMAT),
      isNew: !row.is_viewed
    }
  });
}
